exports.f = require('./_wks');


//////////////////
// WEBPACK FOOTER
// /Users/sameer/Documents/projects/release/metabase/~/core-js/modules/_wks-ext.js
// module id = 27
// module chunks = 0 3 5